module.exports = __webpack_public_path__ + "static/media/cover-canada.a80dee03.png";